import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { OptionApis, OptionStatusJudicial } from "utils/enumSelect";
import { JudicialRecordsContext } from "./JudicialRecordsContext";
import httpMethod from 'services/update2025/httpMethod';
import { listJudicialRecords } from "services/JudicialRecordsService";
import { InputText } from "primereact/inputtext";

const SearchForm = () => {
    //! define

    //! state
    const { t, i18n } = useTranslation(["judicial-records", "common"]);

    const judicialContext = useContext(JudicialRecordsContext);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    const { dataSearch, setDataSearch, setSelectedItem, lazyParams, setLazyParams, setTotalRecords, setListJudicial, setLoading, checkLoad, setCheckLoad } = judicialContext;

    //! function
    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const getListJudicialRecords = () => {
        setLoading(true);
        const body = {
            page: lazyParams.page,
            size: lazyParams.rows,
            idNumber: null,
            type: dataSearch.nameApi,
            status: dataSearch.status,
            profileCode: dataSearch.code,
            fromDate: null,
            toDate: null,
        };
        listJudicialRecords(headers, body)
            .then((res) => {
                if (res.status === 200) {
                    setTotalRecords(res.data.totalRecord);
                    setListJudicial(res.data.logs);
                }
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    };

    //! useEffect
    useEffect(() => {
        getListJudicialRecords();
    }, [lazyParams]);

    //! render
    return (
        <div className="grid" style={{ width: "100%" }}>
            <div className="col-12">
                <BlockDetail title={t("search", { ns: "common" })}>
                    <div className="grid">
                        <div className="col-12 md:col-3">
                            <div className="grid custom-form">
                                <label
                                    className="col-fixed text-center"
                                    style={{
                                        width: "80px",
                                        display: "flex",
                                        padding: "0.75rem 0px 0px 0.5rem",
                                    }}
                                    htmlFor="type"
                                >
                                    {t("judicial-records.nameApi")}
                                </label>
                                <Dropdown
                                    className="col"
                                    value={dataSearch.nameApi}
                                    style={{ width: "100%", margin: "7px" }}
                                    showClear={true}
                                    id="nameApi"
                                    name="nameApi"
                                    options={OptionApis}
                                    onChange={(e) => {
                                        setDataSearch({
                                            ...dataSearch,
                                            nameApi: e.value,
                                        });
                                    }}
                                ></Dropdown>
                            </div>
                        </div>
                        <div className="col-12 md:col-3">
                            <div className="grid custom-form">
                                <label className="col-fixed text-center" style={{ display: "flex", padding: "0.75rem 0px 0px 0.5rem" }} htmlFor="factoryName">
                                    {t("judicial-records.profileCode")}
                                </label>
                                <div className="col">
                                    <InputText
                                        style={{ width: "100%" }}
                                        id="code"
                                        name="code"
                                        onChange={(e) => {
                                            setCheckLoad(false);
                                            setDataSearch({
                                                ...dataSearch,
                                                code: e.target.value,
                                            });
                                        }}
                                    ></InputText>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 md:col-2">
                            <div className="grid custom-form">
                                <label className="col-fixed text-center" style={{ display: "flex", padding: "0.75rem 0px 0px 0.5rem" }} htmlFor="factoryName">
                                    {t("judicial-records.unitCode")}
                                </label>
                                <div className="col">
                                    <InputText
                                        style={{ width: "100%" }}
                                        id="code"
                                        name="code"
                                        onChange={(e) => {
                                            setCheckLoad(false);
                                            setDataSearch({
                                                ...dataSearch,
                                                unitCode: e.value,
                                            });
                                        }}
                                    ></InputText>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 md:col-2">
                            <div className="grid custom-form">
                                <label
                                    className="col-fixed text-center"
                                    style={{
                                        width: "80px",
                                        display: "flex",
                                        padding: "0.75rem 0px 0px 0.5rem",
                                    }}
                                    htmlFor="type"
                                >
                                    {t("judicial-records.status")}
                                </label>
                                <Dropdown
                                    className="col"
                                    value={dataSearch.status}
                                    style={{ width: "100%", margin: "7px" }}
                                    showClear={true}
                                    id="status"
                                    name="status"
                                    options={OptionStatusJudicial}
                                    onChange={(e) => {
                                        setDataSearch({
                                            ...dataSearch,
                                            status: e.value,
                                        });
                                    }}
                                ></Dropdown>
                            </div>
                        </div>
                        <div className="col-12 md:col-2 text-right">
                            <div className="grid custom-form">
                                <div className="col-12">
                                    <label
                                        style={{
                                            // width: "130px",
                                            // justifyContent: "end",
                                            display: "flex",
                                            padding: "0.75rem 0px 0px 0.5rem",
                                        }}
                                    >
                                        {" "}
                                    </label>
                                </div>
                                <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                                    <Button
                                        label={t("search", { ns: "common" })}
                                        icon="pi pi-search"
                                        onClick={(e) => {
                                            setLazyParams({
                                                ...lazyParams,
                                                first: 0,
                                                page: 0,
                                            });
                                            getListJudicialRecords();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </BlockDetail>
            </div>
        </div>
    );
};

export default SearchForm;
